<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">船社別フリータイム一覧</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          v-permit.SHARP_FREETIME_SEARCH
          @click="search()"
          class="btn-search"
          >{{ $t("app.buttons.search") }}</v-btn
        >
        <v-btn v-permit.SHARP_FREETIME_NEW to="/M0260/new">{{
          $t("app.buttons.new")
        }}</v-btn>
        <v-btn
          v-permit.SHARP_FREETIME_EDIT
          @click="edit()"
          :disabled="selected.length !== 1"
          >{{ $t("app.buttons.edit") }}</v-btn
        >
        <v-btn
          v-permit.SHARP_FREETIME_EDIT
          @click="remove()"
          :disabled="selected.length !== 1"
          >{{ $t("app.buttons.remove") }}</v-btn
        >
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.forwarder')"
                url="companies/forwarders/kv"
                v-model="query.forwarderId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="積出港"
                url="ports/kv"
                v-model="query.loadingPortCode"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="陸揚港"
                url="ports/kv"
                v-model="query.dischargePortCode"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3> </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="pagination.content"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>
            {{ props.item.forwarderCode + ":" + props.item.forwarderName }}
          </td>
          <td>
            {{ getPort(props.item.freeDaysPortVos, "LOADING_PORT", true) }}
          </td>
          <td>
            {{
              getPort(props.item.freeDaysPortVos, "EXCEPT_LOADING_PORT", false)
            }}
          </td>
          <td>
            {{ getPort(props.item.freeDaysPortVos, "DISCHARGE_PORT", true) }}
          </td>
          <td>
            {{
              getPort(
                props.item.freeDaysPortVos,
                "EXCEPT_DISCHARGE_PORT",
                false
              )
            }}
          </td>
          <td>{{ props.item.freeDays }}</td>
          <td>{{ props.item.freeDaysType }}</td>
          <td>{{ props.item.standard }}</td>
          <td>{{ props.item.remark }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      selected: [],
      results: [],
      displayResults: [],
      loading: false,
      pagination: {
        page: 1,
      },
      query: {},
      headers: [
        {
          text: this.$t("app.labels.forwarder"),
          value: "forwarderCode",
          sortable: false,
        },
        {
          text: "積出港",
          value: "partnerCode",
          sortable: false,
        },
        {
          text: "除外積出港",
          value: "partnerCode",
          sortable: false,
        },
        {
          text: "陸揚港",
          value: "partnerCode",
          sortable: false,
        },
        {
          text: "除外陸揚港",
          value: "partnerCode",
          sortable: false,
        },
        {
          text: "Free Days",
          value: "partnerCode",
          sortable: false,
        },
        {
          text: "日数カウント",
          value: "partnerCode",
          sortable: false,
        },
        {
          text: "基準日",
          value: "partnerCode",
          sortable: false,
        },
        {
          text: "備考",
          value: "partnerCode",
          sortable: false,
        },
      ],
    };
  },

  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
          sort: "freeDaysType",
        },
      };
    },
    search() {
      this.pagination.page = 0;
      this.load();
    },
    load() {
      this.autoload = true;
      this.$storeParams();
      this.loading = true;
      this.$http
        .get("/free-days", this.params())
        .then((res) => {
          this.$pagination(res.data);
          this.loading = false;
          this.selected = [];
        })
        .catch(() => {
          this.loading = false;
        });
    },
    edit() {
      this.$router.push({
        path: "M0260/edit",
        query: { id: this.selected[0].id },
      });
    },
    remove() {
      this.$confirm({
        content: this.$t("app.messages.removeConfirm"),
      }).then(() => {
        this.$http
          .delete(`free-days/${this.selected[0].id}`)
          .then(() => {
            this.load();
            this.$message("", this.$t("app.messages.removeSuccess"));
            this.selected = [];
          })
          .catch((err) => {
            this.$showError(err);
          });
      });
    },
    getPort(portList, type, showAll) {
      var list = portList.filter((p) => type === p.portType);
      if (list.length === 0) {
        return showAll ? "ALL" : "";
      } else {
        return list.map((l) => l.portCode).join(",");
      }
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load();
    },
  },
  mounted() {
    this.$loadParams();
  },
};
</script>
